/** Filtros da fila da Reunião Clínica preservados ao navegar entre fila, paciente e alocação. */
const key = (meetingId) => `erimus.meeting-filters.${meetingId}`;

export const EMPTY_MEETING_FILTERS = { q: "", counselor: "", psychologist: "", psychiatrist: "", ward: "all" };

export const readMeetingFilters = (meetingId) => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(key(meetingId)) || "null");
    return stored ? { ...EMPTY_MEETING_FILTERS, ...stored } : { ...EMPTY_MEETING_FILTERS };
  } catch {
    return { ...EMPTY_MEETING_FILTERS };
  }
};

export const writeMeetingFilters = (meetingId, filters) => {
  try {
    sessionStorage.setItem(key(meetingId), JSON.stringify(filters));
  } catch {
    /* sessão sem armazenamento: filtros valem apenas na tela atual */
  }
};

export const readMeetingWard = (meetingId) => readMeetingFilters(meetingId).ward || "all";
